
export const resourcesFilters = [
    {
      text: "All Resources",
      id: 1,
    },
    {
      text: "Language Basics",
      id: 1.99,
    },
    {
      text: "DSA Topic",
      id: 2,
    },
    {
      text: "Dynamic Programming",
      id: 3,
    },
    {
      text: "Data Structures",
      id: 4,
    },
    // {
    //   text: "Non-Linear Data Structures",
    //   id: 5,
    // },
    // {
    //   text: "Tree",
    //   id: 6,
    // },
    // {
    //   text: "Graph Theory",
    //   id: 7,
    // },
    // {
    //   text: "",
    //   id: 8,
    // },
    {
      text: "Web Development",
      id: 9,
    },
    {
      text: "Github",
      id: 10,
    },
    {
      text: "Theory Subjects",
      id: 11,
    },
    {
      text: "Interview Preparation",
      id: 12,
    },
    {
      text: "Machine Learning",
      id: 13,
    },
  ];
  